import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-purchase-confirmed',
  templateUrl: './purchase-confirmed.component.html',
  styleUrls: ['./purchase-confirmed.component.scss']
})
export class PurchaseConfirmedComponent {
  constructor(private router: Router) { }

  redirectNow(): void {
    this.router.navigate(['']);
  }
}
